import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";
// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess } from "./actions";

import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";

import {
  ORGANIZATION,
  CANDIDATE,
  RECRUITER,
  ADMIN,
} from "../../../common/constant/LoginEnum";
import { verifyData } from "../../../pages/Common/CommonFunctions/commonFunctions";

const verifyOrgRoute = (route) => {
  if (route.includes("/recruiter")) {
    return "/dashboard";
  } else {
    return route;
  }
};

const verifyRecruiterRouter = (route) => {
  if (
    route === "/job/open" ||
    route === "/job/closed" ||
    route === "/job/add" ||
    route === "/job/edit" ||
    route === "/job?type=JD" ||
    route === "/dashboard"
  ) {
    return "/recruiter/dashboard";
  } else {
    return route;
  }
};

const verifyAdminRouter = (route) => {
  if (route.includes("admin")) {
    return route;
  } else {
    return "/admin/dashboard";
  }
};

function* loginUser({ payload: { user, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      let response;
      if (user.module === "Candidate" || user.module === "CANDIDATE") {
        var url = constClass.REST_API_LOGIN_URL_CANDIDATE;
        response = yield call(postJwtLogin, url, user);
      } else if (
        user.module === "Organization" ||
        user.module === "ORGANIZATION"
      ) {
        var url2 = constClass.REST_API_LOGIN_URL_ORGANIZATION;
        response = yield call(postJwtLogin, url2, user);
      } else if (user.module === "Admin" || user.module === "ADMIN") {
        var url3 = constClass.REST_API_LOGIN_URL_ADMIN;
        response = yield call(postJwtLogin, url3, user);
      } else {
        var url4 = constClass.REST_API_LOGIN_URL_RECRUITER;
        response = yield call(postJwtLogin, url4, user);
      }

      if ("error" in response) {
        yield put(apiError(response.error));
        localStorage.setItem("isAuthProtected", false);
      } else {
        var userData = JSON.parse(JSON.stringify(response));
        if (userData.userType === ADMIN) {
          localStorage.setItem("authUser", JSON.stringify(response));
          localStorage.setItem("isAuthProtected", true);
          const data = JSON.parse(localStorage.getItem("prevRoute"));
          if (verifyData(data)) {
            if (userData.userType === ADMIN) {
              window.location.href = verifyData(data.previousRoute)
                ? verifyAdminRouter(data.previousRoute)
                : "/admin/dashboard";
              localStorage.removeItem("prevRoute");
            }
          } else {
            window.location.href = "/admin/dashboard";
          }
        } else if (
          userData.userType === ORGANIZATION ||
          userData.userType === RECRUITER
        ) {
          if (!userData.profileUpdated && userData.companyAdmin) {
            localStorage.setItem("authUser", JSON.stringify(response));
            localStorage.setItem("isAuthProtected", true);
            yield put(loginSuccess(response));
            history.push("/candidates");
          } else {
            localStorage.setItem("authUser", JSON.stringify(response));
            localStorage.setItem("isAuthProtected", true);
            yield put(loginSuccess(response));
            if (user.redirecTo != null) {
              window.location.href = user.redirecTo;
            } else {
              const data = JSON.parse(localStorage.getItem("prevRoute"));
              if (verifyData(data)) {
                if (userData.userType === RECRUITER) {
                  window.location.href = verifyData(data.previousRoute)
                    ? verifyRecruiterRouter(data.previousRoute)
                    : "/recruiter/dashboard";
                  localStorage.removeItem("prevRoute");
                } else {
                  window.location.href = verifyData(data.previousRoute)
                    ? verifyOrgRoute(data.previousRoute)
                    : "/dashboard";
                  localStorage.removeItem("prevRoute");
                }
              } else {
                if (userData.userType === RECRUITER) {
                  window.location.href = "/recruiter/dashboard";
                } else {
                  window.location.href = "/dashboard";
                }
              }
            }
          }
        } else if (userData.userType === "Recruiter") {
          let redirectUrl = "/dashboard";
          if (!response.showRecruiterCompany) {
            redirectUrl = "/recruiter/candidate/viewall";
          }
          localStorage.setItem("authUser", JSON.stringify(response));
          localStorage.setItem("isAuthProtected", true);
          yield put(loginSuccess(response));
          localStorage.setItem("authUser", JSON.stringify(response));
          localStorage.setItem("isAuthProtected", true);
          yield put(loginSuccess(response));
          if (user.redirecTo != null) {
            window.location.href = user.redirecTo;
          } else {
            window.location.href = redirectUrl;
          }
        }
      }
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fakebackend") {
      const response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      });
      localStorage.setItem("isAuthProtected", false);
      localStorage.setItem("authUser", JSON.stringify(response));

      yield put(loginSuccess(response));
    }
    //history.push("/orgdashboard")
  } catch (error) {
    localStorage.removeItem("authUser");
    localStorage.setItem("isAuthProtected", false);
    yield put(apiError(error));
  }
}
function* logoutUser({ payload: { history } }) {
  try {
    var userData = JSON.parse(localStorage.getItem("authUser"));
    var userType = userData.userType;

    localStorage.removeItem("authUser");
    localStorage.setItem("isAuthProtected", false);
    localStorage.removeItem("setpassword");
    localStorage.removeItem("adminAuth");
    localStorage.removeItem("impersonationMode");
    // delete show logo banner session
    localStorage.removeItem("showLogoBanner");
    if (userType === CANDIDATE) {
      history.push("/login/candidate");
    } else if (userType === ORGANIZATION) {
      history.push("/login/organization");
    } else if (userType === RECRUITER) {
      history.push("/login");
    } else if (userType === ADMIN) {
      history.push("/login/admin");
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    let url;
    if (type === "google") {
      if (data.module === ORGANIZATION) {
        url = constClass.REST_API_SOCIAL_LOGIN_GOOGLE_ORGANIZATION;
      } else if (data.module === CANDIDATE) {
        url = constClass.REST_API_SOCIAL_LOGIN_GOOGLE_CANDIDATE;
      } else if (data.module === RECRUITER) {
        url = constClass.REST_API_SOCIAL_LOGIN_GOOGLE_RECRUITER;
      } else if (data.module === ADMIN) {
        url = constClass.REST_API_SOCIAL_LOGIN_GOOGLE_ADMIN;
      } else {
        url = constClass.REST_API_SOCIAL_LOGIN_GOOGLE;
      }
    }

    const response = yield call(postSocialLogin, url, data);
    var userData = JSON.parse(JSON.stringify(response));
    localStorage.setItem("authUser", JSON.stringify(response));
    yield put(loginSuccess(response));
    localStorage.setItem("isAuthProtected", true);
    if (userData.userType === "Candidate") {
      localStorage.setItem("authUser", JSON.stringify(response));
      localStorage.setItem("isAuthProtected", true);
      yield put(loginSuccess(response));
      if (data.redirecTo != null) {
        history.push(data.redirecTo);
      } else {
        history.push("/candidatedashboard");
      }
    } else if (userData.userType === "Organization") {
      if (!userData.profileUpdated) {
        localStorage.setItem("authUser", JSON.stringify(response));
        localStorage.setItem("isAuthProtected", true);
        yield put(loginSuccess(response));
        history.push("/dashboard");
      } else {
        localStorage.setItem("authUser", JSON.stringify(response));
        localStorage.setItem("isAuthProtected", true);
        yield put(loginSuccess(response));
        if (data.redirecTo != null) {
          history.push(data.redirecTo);
        } else {
          history.push("/dashboard");
        }
        history.push("/dashboard");
      }
    } else if (userData.userType === "Recruiter") {
      let redirectUrl = "/dashboard";
      if (!response.showRecruiterCompany) {
        redirectUrl = "/recruiter/candidate/viewall";
      }

      localStorage.setItem("authUser", JSON.stringify(response));
      localStorage.setItem("isAuthProtected", true);
      yield put(loginSuccess(response));
      history.push(redirectUrl);
    } else if (userData.userType === ADMIN) {
      console.log("adminnnn");
      let redirectUrl = "/admin/dashboard";
      localStorage.setItem("authUser", JSON.stringify(response));
      localStorage.setItem("isAuthProtected", true);
      yield put(loginSuccess(response));
      history.push(redirectUrl);
      return;
    }
    userData.userType === RECRUITER
      ? history.push("/recruiter/dashboard")
      : history.push("/dashboard");
  } catch (error) {
    localStorage.removeItem("authUser");
    localStorage.setItem("isAuthProtected", false);
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
